module.exports = __webpack_public_path__ + "be027a977050ea00685a8fca398849dd.svg";